import React, { useState, useEffect } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Input, Row, Col } from "reactstrap";
import PropTypes from "prop-types";

const MonthlyParkingCustomerModal = ({ customer, onClose, onEdit }) => {
    const [isEditing, setIsEditing] = useState(false);
    const [form, setForm] = useState(customer || {});

    useEffect(() => {
        if (customer) {
            console.log("customer: ", customer)
            setForm({
                ...customer,
                customer_first_name: customer.customer_first_name || "",
                customer_last_name: customer.customer_last_name || "",
                customer_email: customer.customer_email || "",
                customer_phone: customer.customer_phone || "",
                customer_company_name: customer.customer_company_name || "",
            });
            setIsEditing(false);
        }
    }, [customer]);

    if (!customer) return null;

    const handleChange = (key, val) => setForm((prev) => ({ ...prev, [key]: val }));

    const handleSave = () => {
        onEdit({
            id: form.id,
            editType: "customer",
            customer_first_name: form.customer_first_name || "",
            customer_last_name: form.customer_last_name || "",
            customer_email: form.customer_email || "",
            customer_phone: form.customer_phone || "",
            customer_company_name: form.customer_company_name || "",
        });
        setIsEditing(false);
    };

    return (
        <Modal isOpen={!!customer} toggle={onClose}>
            <ModalHeader toggle={onClose}>Customer Details</ModalHeader>
            <ModalBody>
                {isEditing ? (
                    <>
                        <Row>
                            <Col md={6}>
                                <label><b>First Name:</b></label>
                                <Input
                                    value={form.customer_first_name || ""}
                                    onChange={(e) => handleChange("customer_first_name", e.target.value)}
                                />
                            </Col>
                            <Col md={6}>
                                <label><b>Last Name:</b></label>
                                <Input
                                    value={form.customer_last_name || ""}
                                    onChange={(e) => handleChange("customer_last_name", e.target.value)}
                                />
                            </Col>
                        </Row>

                        <div className="mt-3">
                            <label><b>Email:</b></label>
                            <Input
                                value={form.customer_email || ""}
                                onChange={(e) => handleChange("customer_email", e.target.value)}
                            />
                        </div>

                        <div className="mt-3">
                            <label><b>Phone:</b></label>
                            <Input
                                value={form.customer_phone || ""}
                                onChange={(e) => handleChange("customer_phone", e.target.value)}
                            />
                        </div>

                        <div className="mt-3">
                            <label><b>Company:</b></label>
                            <Input
                                value={form.customer_company_name || ""}
                                onChange={(e) => handleChange("customer_company_name", e.target.value)}
                            />
                        </div>
                    </>
                ) : (
                    <>
                        <div className="mb-2"><b>First Name:</b> {form.customer_first_name || "-"}</div>
                        <div className="mb-2"><b>Last Name:</b> {form.customer_last_name || "-"}</div>
                        <div className="mb-2"><b>Email:</b> {form.customer_email || "-"}</div>
                        <div className="mb-2"><b>Phone:</b> {form.customer_phone || "-"}</div>
                        <div className="mb-2"><b>Company:</b> {form.customer_company_name || "-"}</div>
                    </>
                )}

                <div className="mt-3">
                    <b>License Plates:</b> {form.license_plates || "-"}
                </div>

                <div className="mt-2">
                    <b>Car Models:</b> {form.car_models || "-"}
                </div>
            </ModalBody>

            <ModalFooter>
                {isEditing ? (
                    <>
                        <Button color="primary" onClick={handleSave}>
                            Save
                        </Button>
                        <Button color="secondary" onClick={() => setIsEditing(false)}>
                            Cancel
                        </Button>
                    </>
                ) : (
                    <Button color="secondary" onClick={() => setIsEditing(true)}>
                        Edit
                    </Button>
                )}
            </ModalFooter>
        </Modal>
    );
};

MonthlyParkingCustomerModal.propTypes = {
    customer: PropTypes.object,
    onClose: PropTypes.func.isRequired,
    onEdit: PropTypes.func.isRequired,
};

export default MonthlyParkingCustomerModal;